import { useNavigate } from 'react-router-dom';
import useTicketDetail from '../../component/hooks/useTicketDetail';
import TicketDetailUI from '../../component/tickets/TicketDetailUI';

export default function TicketDetailPage({id,openType,...props}) {
  const navigate = useNavigate();

  const {
    detail, loading, error,
    sending, sendMessage,
  } = useTicketDetail(id, true);

  return (
    <TicketDetailUI
      detail={detail}
      loading={loading}
      error={error}
      sending={sending}
      onSend={sendMessage}
      openType={openType}
      onGoAssignment={(assignmentId) => navigate(`/boost-assignment/${assignmentId}`)}
    />
  );
}
